<template>
    <div class="BaseArticlePage">
      <BaseCommonPage>
        <div v-bind:is="component"></div>

        <div class="container fun_top">
          <p class="text-center">
            <FuncSearchGalleryTop>
              <LabelFunMessage fcontId="0" msgkey="180" /> &raquo;
            </FuncSearchGalleryTop>
          </p>
        </div>

        <InstaGalleryButton />
      </BaseCommonPage>
    </div>
</template>

<script>

import NormalFcont1 from './normal_fcont_1'
import NormalFcont2 from './normal_fcont_2'
import NormalFcont3 from './normal_fcont_3'
import NormalFcont4 from './normal_fcont_4'
import NormalFcont5 from './normal_fcont_5'
import NormalFcont6 from './normal_fcont_6'
import NormalFcont7 from './normal_fcont_7'
import NormalFcont8 from './normal_fcont_8'
import NormalFcont9 from './normal_fcont_9'
import NormalFcont10 from './normal_fcont_10'
import NormalFcont11 from './normal_fcont_11'
import NormalFcont12 from './normal_fcont_12'
import NormalFcont13 from './normal_fcont_13'
import NormalFcont14 from './normal_fcont_14'
import NormalFcont15 from './normal_fcont_15'
import NormalFcont16 from './normal_fcont_16'
import NormalFcont17 from './normal_fcont_17'
import NormalFcont18 from './normal_fcont_18'
import NormalFcont19 from './normal_fcont_19'
import NormalFcont20 from './normal_fcont_20'
import NormalFcont21 from './normal_fcont_21'
import NormalFcont22 from './normal_fcont_22'
import NormalFcont23 from './normal_fcont_23'
import NormalFcont24 from './normal_fcont_24'
import NormalFcont25 from './normal_fcont_25'
import NormalFcont26 from './normal_fcont_26'
import NormalFcont27 from './normal_fcont_27'
import NormalFcont28 from './normal_fcont_28'
import NormalFcont29 from './normal_fcont_29'
import NormalFcont30 from './normal_fcont_30'
import NormalFcont31 from './normal_fcont_31'
import NormalFcont32 from './normal_fcont_32'
import NormalFcont33 from './normal_fcont_33'
import NormalFcont34 from './normal_fcont_34'
import NormalFcont35 from './normal_fcont_35'
import NormalFcont36 from './normal_fcont_36'
import NormalFcont37 from './normal_fcont_37'
import NormalFcont38 from './normal_fcont_38'
import NormalFcont39 from './normal_fcont_39'
import NormalFcont40 from './normal_fcont_40'
import NormalFcont41 from './normal_fcont_41'
import NormalFcont42 from './normal_fcont_42'
import NormalFcont43 from './normal_fcont_43'
import NormalFcont44 from './normal_fcont_44'
import NormalFcont46 from './normal_fcont_46'
import NormalFcont47 from './normal_fcont_47'
import NormalFcont48 from './normal_fcont_48'
import NormalFcont49 from './normal_fcont_49'
import NormalFcont50 from './normal_fcont_50'
import NormalFcont51 from './normal_fcont_51'
import NormalFcont52 from './normal_fcont_52'
import NormalFcont53 from './normal_fcont_53'
import NormalFcont54 from './normal_fcont_54'
import NormalFcont55 from './normal_fcont_55'
import NormalFcont56 from './normal_fcont_56'
import NormalFcont57 from './normal_fcont_57'
import NormalFcont58 from './normal_fcont_58'
import NormalFcont59 from './normal_fcont_59'
import NormalFcont60 from './normal_fcont_60'
import NormalFcont61 from './normal_fcont_61'
import NormalFcont62 from './normal_fcont_62'
import NormalFcont63 from './normal_fcont_63'
import NormalFcont64 from './normal_fcont_64'
import NormalFcont65 from './normal_fcont_65'
import NormalFcont66 from './normal_fcont_66'
import NormalFcont67 from './normal_fcont_67'
import NormalFcont68 from './normal_fcont_68'
import NormalFcont69 from './normal_fcont_69'
import NormalFcont70 from './normal_fcont_70'
import NormalFcont71 from './normal_fcont_71'
import NormalFcont72 from './normal_fcont_72'
import NormalFcont73 from './normal_fcont_73'
import NormalFcont75 from './normal_fcont_75'
import NormalFcont77 from './normal_fcont_77'
import NormalFcont78 from './normal_fcont_78'
import NormalFcont79 from './normal_fcont_79'
import NormalFcont80 from './normal_fcont_80'
import NormalFcont81 from './normal_fcont_81'
import NormalFcont82 from './normal_fcont_82'
import NormalFcont83 from './normal_fcont_83'
import NormalFcont84 from './normal_fcont_84'
import NormalFcont85 from './normal_fcont_85'
import NormalFcont86 from './normal_fcont_86'
import NormalFcont87 from './normal_fcont_87'
import NormalFcont88 from './normal_fcont_88'
import NormalFcont89 from './normal_fcont_89'
import NormalFcont90 from './normal_fcont_90'
import NormalFcont91 from './normal_fcont_91'
import NormalFcont92 from './normal_fcont_92'
import NormalFcont93 from './normal_fcont_93'
import NormalFcont94 from './normal_fcont_94'
import NormalFcont95 from './normal_fcont_95'
import NormalFcont96 from './normal_fcont_96'
import NormalFcont97 from './normal_fcont_97'
import NormalFcont98 from './normal_fcont_98'
import NormalFcont99 from './normal_fcont_99'
import NormalFcont100 from './normal_fcont_100'
import NormalFcont101 from './normal_fcont_101'
import NormalFcont102 from './normal_fcont_102'
import NormalFcont103 from './normal_fcont_103'
import NormalFcont105 from './normal_fcont_105'
import NormalFcont108 from './normal_fcont_108'
import NormalFcont109 from './normal_fcont_109'
import NormalFcont110 from './normal_fcont_110'
import NormalFcont113 from './normal_fcont_113'
import NormalFcont114 from './normal_fcont_114'
import NormalFcont115 from './normal_fcont_115'
import NormalFcont116 from './normal_fcont_116'
import NormalFcont117 from './normal_fcont_117'
import NormalFcont118 from './normal_fcont_118'
import NormalFcont121 from './normal_fcont_121'
import NormalFcont122 from './normal_fcont_122'
import NormalFcont123 from './normal_fcont_123'
import NormalFcont124 from './normal_fcont_124'
import NormalFcont125 from './normal_fcont_125'
import NormalFcont126 from './normal_fcont_126'
import NormalFcont127 from './normal_fcont_127'
import NormalFcont128 from './normal_fcont_128'
import NormalFcont129 from './normal_fcont_129'
import NormalFcont130 from './normal_fcont_130'
import NormalFcont131 from './normal_fcont_131'
import NormalFcont132 from './normal_fcont_132'
import NormalFcont133 from './normal_fcont_133'
import NormalFcont134 from './normal_fcont_134'
import NormalFcont135 from './normal_fcont_135'
import NormalFcont141 from './normal_fcont_141'
import NormalFcont143 from './normal_fcont_143'
import NormalFcont144 from './normal_fcont_144'
import NormalFcont145 from './normal_fcont_145'
import NormalFcont146 from './normal_fcont_146'
import NormalFcont147 from './normal_fcont_147'
import NormalFcont148 from './normal_fcont_148'
import NormalFcont149 from './normal_fcont_149'
import NormalFcont150 from './normal_fcont_150'
import NormalFcont151 from './normal_fcont_151'
import NormalFcont152 from './normal_fcont_152'
import NormalFcont153 from './normal_fcont_153'
import NormalFcont158 from './normal_fcont_158'
import NormalFcont159 from './normal_fcont_159'
import NormalFcont160 from './normal_fcont_160'
import NormalFcont161 from './normal_fcont_161'
import NormalFcont162 from './normal_fcont_162'
import NormalFcont163 from './normal_fcont_163'
import NormalFcont164 from './normal_fcont_164'
import NormalFcont165 from './normal_fcont_165'
import NormalFcont166 from './normal_fcont_166'
import NormalFcont168 from './normal_fcont_168'
import NormalFcont169 from './normal_fcont_169'
import NormalFcont170 from './normal_fcont_170'
import NormalFcont171 from './normal_fcont_171'
import NormalFcont176 from './normal_fcont_176'
import NormalFcont177 from './normal_fcont_177'
import NormalFcont178 from './normal_fcont_178'
import NormalFcont179 from './normal_fcont_179'
import NormalFcont180 from './normal_fcont_180'
import NormalFcont181 from './normal_fcont_181'
import NormalFcont186 from './normal_fcont_186'
import NormalFcont187 from './normal_fcont_187'
import NormalFcont190 from './normal_fcont_190'
import NormalFcont191 from './normal_fcont_191'
import NormalFcont192 from './normal_fcont_192'
import NormalFcont193 from './normal_fcont_193'
import NormalFcont194 from './normal_fcont_194'
import NormalFcont196 from './normal_fcont_196'
import NormalFcont197 from './normal_fcont_197'
import NormalFcont198 from './normal_fcont_198'
import NormalFcont199 from './normal_fcont_199'
import NormalFcont200 from './normal_fcont_200'
import NormalFcont201 from './normal_fcont_201'
import NormalFcont202 from './normal_fcont_202'

import BaseCommonPage from './BaseCommonPage'
import Top from './Top'
import FuncSearchGalleryTop from "../components/FuncSearchGalleryTop"
import InstaGalleryButton from "../components/InstaGalleryButton"
import LabelFunMessage from "../components/LabelFunMessage"
import FuncSearchRecommendLink from "../components/FuncSearchRecommendLink"
import { mapGetters } from "vuex";
export default {
  name: 'BaseArticlePage',
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    };
  },
  props: {
    id: String
  },
  components: {
    NormalFcont1,NormalFcont2, NormalFcont3,NormalFcont4, NormalFcont5,NormalFcont6,NormalFcont7,NormalFcont8,NormalFcont9,
    NormalFcont10,NormalFcont11,NormalFcont12,NormalFcont13,NormalFcont14,NormalFcont15,NormalFcont16,NormalFcont17,NormalFcont18,NormalFcont19,
    NormalFcont20,NormalFcont21,NormalFcont22,NormalFcont23,NormalFcont24,NormalFcont25,NormalFcont26,NormalFcont27,NormalFcont28,NormalFcont29,
    NormalFcont30,NormalFcont31,NormalFcont32,NormalFcont33,NormalFcont34,NormalFcont35,NormalFcont36,NormalFcont37,NormalFcont38,NormalFcont39,
    NormalFcont40,NormalFcont41,NormalFcont42,NormalFcont43,NormalFcont44,
    NormalFcont46,NormalFcont47,NormalFcont48,NormalFcont49,
    NormalFcont50,NormalFcont51,NormalFcont52,NormalFcont53,NormalFcont54,NormalFcont55,NormalFcont56,NormalFcont57,NormalFcont58,NormalFcont59,
    NormalFcont60,NormalFcont61,NormalFcont62,NormalFcont63,NormalFcont64,NormalFcont65,NormalFcont66,NormalFcont67,NormalFcont68,NormalFcont69,
    NormalFcont70,NormalFcont71,NormalFcont72,NormalFcont73,NormalFcont75,NormalFcont77,NormalFcont78,NormalFcont79,
    NormalFcont80,NormalFcont81,NormalFcont82,NormalFcont83,NormalFcont84,NormalFcont85,NormalFcont86,NormalFcont87,NormalFcont88,NormalFcont89,
    NormalFcont90,NormalFcont91,NormalFcont92,NormalFcont93,NormalFcont94,NormalFcont95,NormalFcont96,NormalFcont97,NormalFcont98,NormalFcont99,
    NormalFcont100,NormalFcont101,NormalFcont102,NormalFcont103,NormalFcont105,NormalFcont108,NormalFcont109,
    NormalFcont110,NormalFcont113,NormalFcont114, NormalFcont115,NormalFcont116,NormalFcont117,NormalFcont118,
    NormalFcont121,NormalFcont122,NormalFcont123,NormalFcont124,NormalFcont125,NormalFcont126,NormalFcont127,NormalFcont128,NormalFcont129,
    NormalFcont130,NormalFcont131,NormalFcont132,NormalFcont133,NormalFcont134,NormalFcont135,
    NormalFcont141,NormalFcont143,NormalFcont144,NormalFcont145,NormalFcont146,NormalFcont147,NormalFcont148,NormalFcont149,
    NormalFcont150,NormalFcont151,NormalFcont152,NormalFcont153,NormalFcont158,NormalFcont159,
    NormalFcont160,NormalFcont161,NormalFcont162,NormalFcont163,NormalFcont164,NormalFcont165,NormalFcont166,NormalFcont168,NormalFcont169,NormalFcont170,
    NormalFcont171,NormalFcont176,NormalFcont177,NormalFcont178,NormalFcont179,NormalFcont180,NormalFcont181,
    NormalFcont186,NormalFcont187,NormalFcont190,NormalFcont191,NormalFcont192,NormalFcont193,NormalFcont194,NormalFcont196,NormalFcont197,NormalFcont198,NormalFcont199,
    NormalFcont200,NormalFcont201,NormalFcont202,
    BaseCommonPage,
    Top,
    FuncSearchGalleryTop,InstaGalleryButton,LabelFunMessage,FuncSearchRecommendLink
  },
  computed: {
    ...mapGetters(["isJpTemplate"]),
    component: function() {
      const article = this.$store.state.articles.fullArticles.find((article) => {
        return  this.id == article.id ;
      });
      if(article) {
        return  "NormalFcont" + this.id;
      }
      return Top;
    }
  }
}
</script>
<style>
.carousel-indicators {
  bottom: 5px;
}

.carousel-indicators li {
  /* 2020.11.06  インジケーターの大きさおよび余白を1px大きく＆塗りをグレーに変更 */
  width: 8px;
  height: 8px;
  margin-right: 9px;
  margin-left: 9px;
  background: rgba(150,150,150,0.6);

}
.carousel-indicators .active {
  width: 8px;
  height: 8px;
  margin-right: 9px;
  margin-left: 9px;
}
</style>
